import React, { useState, useEffect } from "react";
import { Header } from "../components/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { Carnet } from "../components/Carnet";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const URL_CARNET = process.env.REACT_APP_APIURL;

function CarnetPage() {
  const navigate = useNavigate();
  const [carnet, setCarnet] = useState({});
  const [loading, setLoading] = useState(true);
  const [plantillaCarnet, setPlantillaCarnet] = useState({});

  const obtenerPlantilla = async (TipoCarnet, IdFacultad) => {
    try {
      const response = await axios.post(URL_CARNET + "/templateCard", {
        TipoCarnet,
        IdFacultad,
      });
      return response?.data || [];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (loading) {
      async function fetchData() {
        const Carnet = localStorage.getItem("carnet");
        // const Carnet = 'RV100823';
        const Cmac = localStorage.getItem("cmac");
        try {
          const response = await axios.post(URL_CARNET + "/showCard", {
            Carnet,
            Cmac,
            Email: "",
          });
          const carnet = response?.data || [];
          setCarnet(carnet);
          const plantilla = await obtenerPlantilla(
            carnet?.TipoCarnet,
            carnet?.IdFacultad
          );
          setPlantillaCarnet(plantilla);
        } catch (error) {
          Swal.fire({
            title: '<strong style="color:#EDEEEF;">Lo sentimos</strong>',
            icon: "error",
            html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">${error.response.data.Message}</font></p>`,
            background: "#1E4775",
            showConfirmButton: false,
            showCloseButton: true,
          });
          navigate("/login");
          // console.error(error);
        }
      }
      fetchData();
      setLoading(false);
    }
  }, [loading, navigate]);

  const cerrarSesion = () => {
    localStorage.removeItem("token");
    window.location.reload(true);
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-xl-7 mt-5 pt-5 d-flex align-items-center justify-content-center">
            <Carnet plantilla={plantillaCarnet} estudiante={carnet} />
          </div>
          <div className="col-xl-3 ps-5 mt-5 pt-5 wrap-documentos">
            {!!carnet?.CalificacionesFileName ? <h3 className="text-center mb-5">Documentos</h3> : null}
            <hr className="hr-vertical" />
            <div className="wrap-buttons" style={{ textAlign: '-webkit-center' }}>
              {!!carnet?.CalificacionesFileName ? (
                <div>
                  <a
                    className="link-documentos"
                    href={carnet.CalificacionesFile}
                    download={carnet.CalificacionesFileName}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-cloud-arrow-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                      />
                      <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                    </svg>
                    <span>Constancia de notas</span>
                  </a>
                </div>
              ) : null}
              {!!carnet.InscripcionFileName ? (
                <a
                  href={carnet.InscripcionFile}
                  download={carnet.InscripcionFileName}
                  className="link-documentos"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                    />
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                  </svg>
                  <span>Comprobante de inscripción</span>
                </a>
              ) : null}
              <button className="link-cerrar" onClick={cerrarSesion}>
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CarnetPage;
